@if (showNumeric || showInt) {
  <astral-input type="number" [control]="form.controls['numericValue']"></astral-input>
}
@if (showText) {
  <astral-input [control]="form.controls['textValue']"></astral-input>
}
@if (showBoolean) {
  <astral-checkbox [control]="form.controls['boolValue']"></astral-checkbox>
}
@if (showSelection) {
  <astral-select [control]="form.controls['textValue']" [itemsSource]="selectionItems"></astral-select>
}
@if (showDate) {
  <astral-date-picker [control]="form.controls['dateValue']"></astral-date-picker>
}
